import { render, staticRenderFns } from "./AssertionEditor.vue?vue&type=template&id=3d6d2e13"
import script from "./AssertionEditor.vue?vue&type=script&lang=js"
export * from "./AssertionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports